import React, { useState, useEffect, useContext, useCallback } from "react";
import axios from "axios";
import { AppContext } from "../../../../context/AppContext";
import "../../../../assets/css/patient/patientlayouts/layoutpages/Payment.css";

const Payment = () => {
  const { baseUrl } = useContext(AppContext);

  // NOTE: agar patient token kisi aur localStorage key mein store hota hai
  // (jaise "patientToken"), to sirf yeh line badal dein.
  const token = localStorage.getItem("patient_token");

  const authHeaders = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };

  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPayments = useCallback(() => {
    setLoading(true);
    axios
      .get(`${baseUrl}/Patient/Payment/list`, { headers: authHeaders })
      .then((res) => {
        // Backend "pending" ko already exclude karke bhejta hai — Payment
        // row sirf JazzCash callback ke baad (paid/failed) banti hai.
        setPayments(res.data.data || []);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUrl]);

  useEffect(() => {
    fetchPayments();
  }, [fetchPayments]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };

  return (
    <div className="payment-container">
      {/* Header */}
      <div className="payment-header">
        <h2 className="payment-title">
          <svg className="title-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
          </svg>
          My Payments
        </h2>
        <p className="payment-subtitle">Manage your session payments securely</p>
      </div>

      {/* Payment History */}
      <div className="payment-history">
        <h4>
          <svg className="section-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
          </svg>
          Payment History
        </h4>

        <div className="table-container">
          <table className="payment-table">
            <thead>
              <tr>
                <th>Payment ID</th>
                <th>Appointment</th>
                <th>Doctor</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Method</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7">
                    <div className="empty-state">
                      <p>Loading payments...</p>
                    </div>
                  </td>
                </tr>
              ) : payments.length === 0 ? (
                <tr>
                  <td colSpan="7">
                    <div className="empty-state">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
                      </svg>
                      <h3>No Payment History</h3>
                      <p>You haven't made any payments yet</p>
                    </div>
                  </td>
                </tr>
              ) : (
                payments.map((pay) => (
                  <tr key={pay.id}>
                    <td>
                      <strong>PAY-{String(pay.id).padStart(3, "0")}</strong>
                    </td>
                    <td>APT-{pay.appointment_id}</td>
                    <td>{pay.therapist}</td>
                    <td>{formatDate(pay.date)}</td>
                    <td>
                      <strong>{pay.amount} PKR</strong>
                    </td>
                    <td>
                      <span className={`method-badge ${pay.payment_method}`}>
                        {pay.payment_method === "jazzcash" && "JazzCash"}
                        {pay.payment_method === "easypaisa" && "EasyPaisa"}
                        {pay.payment_method === "card" && "Card"}
                        {!["jazzcash", "easypaisa", "card"].includes(pay.payment_method) && pay.payment_method}
                      </span>
                    </td>
                    <td>
                      {/* Sirf "paid" / "failed" hi possible hain — "pending" backend se
                          kabhi aata hi nahi, is liye yahan handle karne ki zaroorat nahi. */}
                      <span className={`status ${pay.payment_status}`}>
                        <span className="status-icon"></span>
                        {pay.payment_status.charAt(0).toUpperCase() + pay.payment_status.slice(1)}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Payment;